import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import React, { useCallback, useEffect, useState } from "react"
import { loadReleaseDetails } from "./ReleasesApi"
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectSettings } from "../../settings/settingsSlice";
import { If } from "../../../app/If";
import { showDialog } from "../../dialogs/dialogSlice";
import { Localized } from "@fluent/react";
import { ViewList } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

export interface ReleaseDetailsDialogProps {
    id: string;
    loading: boolean;
    outlined?: boolean;
    disabled?: boolean; 
}

export const ReleaseDetailsDialog = (props: ReleaseDetailsDialogProps) => {
    const dispatch = useAppDispatch()
    const { locale } = useAppSelector(selectSettings);

    const [language, setLanguage] = useState<string>(locale);
    const [titlePL, setTitlePL] = useState<string>("");
    const [descriptionPL, setDescriptionPL] = useState<string>("");
    const [titleEN, setTitleEN] = useState<string>("");
    const [descriptionEN, setDescriptionEN] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const result = await dispatch(loadReleaseDetails(props.id))
            
            if (loadReleaseDetails.fulfilled.match(result)) {
                const { payload } = result
                setTitlePL(payload.title)
                setDescriptionPL(payload.content)
                setTitleEN(payload.titleEN)
                setDescriptionEN(payload.contentEN)
            }
        }
        finally {
            setLoading(false)
        }
    }

    const handleLanguageChange = (event: React.MouseEvent<HTMLElement>, newValue: string) => {
        setLanguage(newValue);
    }

    useEffect(() => {
        fetchDetails();
    }, [])

    const closeDialog = useCallback(() => { dispatch(showDialog({ tag: 'none' })) }, [])

    return <Dialog open={true} maxWidth="md" fullWidth>
        <If condition={!loading} otherwise={<DialogContent><CircularProgress/></DialogContent>}>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="releases-preview-long">_Podgląd wiadomości, która zostanie wysłana</Localized>
                    <ToggleButtonGroup
                        exclusive
                        value={language}
                        onChange={handleLanguageChange}
                        >
                        <ToggleButton value="pl">PL</ToggleButton>
                        <ToggleButton value="en-US">EN</ToggleButton>
                    </ToggleButtonGroup>
                </Box>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography><Localized id="title">_Tytuł</Localized>: <b>{ language === "pl" ? titlePL : titleEN }</b></Typography>
                    <Paper elevation={3} sx={{ padding: 3, marginY: 2 }}>
                        <Typography color="text.secondary">
                            <Localized id="releases-content">_Treść</Localized>
                        </Typography>
                        <Content content={language === "pl" ? descriptionPL : descriptionEN} />
                    </Paper>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialog} color="primary">
                    <Localized id="close">_Zamknij</Localized>
                </Button>
            </DialogActions>
        </If>
    </Dialog>
}


export const ReleaseDetailsButton = (props: ReleaseDetailsDialogProps) => {
    const dispatch = useAppDispatch()

    const openDialog = useCallback(() => {
        dispatch(showDialog({ tag: 'releaseDetails', props }))
    }, [props])

    return <LoadingButton loading={props.loading} sx={{ marginLeft: 1 }} size="small" variant={props.outlined ? "outlined" : "contained"} color="primary" startIcon={!props.outlined ? <ViewList /> : null} onClick={openDialog} disabled={props.disabled}>
        <Localized id="releases-preview">_Podgląd wiadomości</Localized>
    </LoadingButton>
}

const Content = (props: { content: string | JSX.Element }) => {
    if (typeof props.content === 'string') {
        return <div dangerouslySetInnerHTML={{ __html: props.content }} />
    } else {
        return props.content
    }
}

